import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
    skeleton: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    skeletonAbsolute: {
        position: 'absolute',
        inset: 0,
    },
    skeletonPadding: {
        padding: tokens.spacingHorizontalM,
    },
    skeletonItem: {
        height: '100%',
    },
});
